import React, { useEffect } from "react";
import useAdmin from "./useAdmin";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import axios from "axios";
import swal from 'sweetalert';
import { useNavigate } from "react-router-dom";
import { formatDateForDB } from "../../bootstrap/ReusableFunctionsBootstrap";

export default function () {
  const { reset, handleSubmit, setErrors, adminFields, setData } = useAdmin();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('admins/create').then(res => {
      setData({ roles: res?.data?.roles });
    });
  }, []);

  const addAdmin = data => {
    data.birthday = typeof data.birthday == "undefined" ? null : formatDateForDB(data.birthday);
    const formData = new FormData();

    Object.entries(data).forEach(([property, value]) => {
      formData.append(`${property}`, value || '');
    });

    axios.post('admins', formData,{
      headers: {
        'Password-reset': true,
      },
    })
      .then(function (res) {
        if (res.status == 200) {
          swal('Admin "' + res.data.status.email + '" has been created successfully!', {
            icon: "success",
          });
          navigate("/admins");
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Add admin">
      <form className="form w-100 row" onSubmit={handleSubmit(addAdmin)}>
        {adminFields}

        <div className="col-12">
          <SubmitButton
            title="Add"
            classes="d-inline-block w-auto"
          />
        </div>
      </form>
    </Card>
  );
}